var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 31.122L8.41992 28.7061L30.1635 6.96252L32.5794 9.37847L10.8359 31.122Z",
    fill: "#16A02C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1636 31.122L32.5796 28.7061L10.8361 6.96252L8.42011 9.37847L30.1636 31.122Z",
    fill: "#16A02C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7ebdeb4b85b03dafc52255a74f073040.svg";
export { ForwardRef as ReactComponent };